/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmergencyAlertPlanDto } from '../../models/emergency-alert-plan-dto';
import { EmergencyAlertPlanForm } from '../../models/emergency-alert-plan-form';

export interface UpdateEmergencyAlertPlanData$Params {

/**
 * customer id
 */
  customerId: number;
      body: EmergencyAlertPlanForm
}

export function updateEmergencyAlertPlanData(http: HttpClient, rootUrl: string, params: UpdateEmergencyAlertPlanData$Params, context?: HttpContext): Observable<StrictHttpResponse<EmergencyAlertPlanDto>> {
  const rb = new RequestBuilder(rootUrl, updateEmergencyAlertPlanData.PATH, 'put');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmergencyAlertPlanDto>;
    })
  );
}

updateEmergencyAlertPlanData.PATH = '/customers/{customerId}/emergency-alarm-plan';
